import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  "@global": {
    body: {
      overflow: (props: any) => (props.show ? "hidden" : "auto"),
    },
  },
  toggleSection: {
    borderBottom: "1px solid #CCC",
    left: 0,
    top: 0,
    right: 0,
    background: "#FFF",
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 20px",
    zIndex: 1,
  },
    estimatePopupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.7)", // 👈 semi-transparent dark background
    zIndex: 999, // keep above everything
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
 
  estimatePopupContainer: {
    position: "fixed",
    background: "#fff",
    left: 100,
    top: 80,
    right: 100,
    bottom: 48,
    padding: "20px 20px 80px",
    overflow: "auto",
    borderRadius: "5px",
    border: "2px solid #CCC",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
  },
  popupTitle: {
    position: "fixed",
    borderBottom: "1px solid #CCC",
    left: 100,
    top: 80,
    right: 100,
    background: "#FFF",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 20px",
    border: "2px solid #CCC",
    borderTopRightRadius: "5px",
    borderTopLeftRadius: "5px",
    zIndex: 1,
    "& h6": {
      padding: "0px",
      fontWeight: "600!important" as any,
    },
  },
  container: {
    border: "1px solid #DDD",
    padding: "10px",
    borderRadius: "5px",
    "& .MuiPaper-root": {
      background: "none",
    },
    "& h6": {
      padding: "0px",
      fontWeight: "600!important" as any,
      color: "#02906f",
    },
    "& .estimateTable": {
      overflow: "auto",
      "& th": {
        textTransform: "none",
        fontWeight: "600!important" as any,
        textAlign: "left",
        border: "none",
        padding: "4px",
      },
      "& td": {
        border: "none",
        padding: "4px",
        "& svg": {
          width: "0.8em",
          height: "0.8em",
        },
        "& .MuiFormControl-root": {
          margin: 0,
          height: "30px",
          "& > div": {
            height: "30px",
          },
          "& input": {
            fontSize: "12px",
          },
          "& select": {
            fontSize: "12px",
          },
        },
        "& .MuiCheckbox-root": {
          margin: 0,
          padding: 0,
          textAlign: "center",
          width: "100%",
        },
      },
    },
  },

  labelBox: {
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    // border: "2px solid #dbdbdb",
    marginTop: "16px !important",
    // background: "#eeecef",
    // paddingTop:'7px !important',
    paddingBottom: "6px",
    paddingLeft: "8px !important",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius: "5px",
    height: "36px",
  },

  //   side bar
  sidebarContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100px",
    backgroundColor: "#ffffff",
    boxShadow: "2px 0px 10px rgba(0, 0, 0, 0.2)",
    transition: "transform 0.3s ease-in-out",
    zIndex: 9,
  },
  sidebarOpen: {
    transform: "translateX(0)",
  },
  sidebarClosed: {
    transform: "translateX(-100%)",
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    opacity: 0,
    transition: "opacity 0.3s ease-in-out",
    pointerEvents: "none",
  },
  overlayVisible: {
    opacity: 1,
    pointerEvents: "auto",
  },
});

export default useStyles;
